import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="*" element={ <App /> } />
        </Routes>
      </Router>
    </HelmetProvider>
  </React.StrictMode>
);

// Routes are prerendered to static HTML at build time (scripts/prerender.js) so
// crawlers/social scrapers get real content + per-page meta. Real users get a
// client render: we deliberately DON'T hydrate — the app renders client-only
// state during render (viewport in Header, auth token, locale dates) that can't
// match a build-time snapshot, and hydrateRoot would throw mismatch errors
// (React #418/#423/#425) on nearly every page. createRoot re-renders cleanly.
ReactDOM.createRoot(rootElement).render(app);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
